import { VDataTable } from 'vuetify/lib'

/**
 * @file DDv2用データテーブル
 * @namespace components
 */

/**
 * @see https://vuetifyjs.com/ja/api/v-data-table/
 * @vue-prop {Boolean} [loading=false]
 * @vue-prop {Object} [headerProps=() => ({ sortByText: '並び替え' })]
 * @vue-prop {Object} [footerProps=() => ({ 'items-per-page-options': [100, 200, 300, 400, 500], showFirstLastPage: true })]
 * @vue-prop {String} [loadingText="検索中のため、少々お待ちください。"]
 * @vue-prop {Number} [itemsPerPage=100]
 * @vue-prop {Boolean} [fixedHeader=true]
 * @vue-prop {String} [locale="ja-jp"]
 * @vue-prop {String} [noDataText="利用可能なデータはありません。"]
 * @vue-prop {Boolean} [calculateEidths=true]
 * @vue-prop {Boolean} [dense=true]
 * @example
 * <dd-data-table
    item-key="hachakutiCd"
    [atmark]click:row="onRowClick"
    :height="tableHeight"
    :headers="headers"
    :items="filteredRows"
    :search="searchText"
    :custom-filter="filtering"/>
 */
export default VDataTable.extend({
  name: 'DdDataTable',
  props: {
    loading: {
      type: Boolean,
      default: false
    },
    headerProps: {
      type: Object,
      default: () => ({ sortByText: '並び替え' })
    },
    footerProps: {
      type: Object,
      default: () => ({
        'items-per-page-options': [100, 200, 300, 400, 500],
        showFirstLastPage: true
      })
    },
    loadingText: {
      type: String,
      default: '検索中のため、少々お待ちください。'
    },
    itemsPerPage: {
      type: Number,
      default: 100
    },
    fixedHeader: {
      type: Boolean,
      default: true
    },
    locale: {
      type: String,
      default: 'ja-jp'
    },
    noDataText: {
      type: String,
      default: '利用可能なデータはありません。'
    },
    calculateEidths: {
      type: Boolean,
      default: true
    },
    dense: {
      type: Boolean,
      default: true
    }
  }
})
